'use strict';
// TODO: Remove from `core-js@4`
require('../modules/es.map.group-by');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/esnext.map.group-by.js
// module id = B1Xl
// module chunks = 0